/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER = project.getFeature(feature.getSettingValue('TIMER'));
    if (!TIMER) {
        return blocks;
    }
    const TIMER_VAR_NAME = TIMER.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${TIMER_VAR_NAME}`;

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `/****${doneLinks[0].getSourceId()}****/` : '';
    const links = project.getNodeLinks(feature, 'timer_start');
    const TIMER_REPEAT = feature.getSettingValue('REPEAT');
    for (let i = 0; i < links.length; i++) {
        const link = links[i];

        const time = project.getNodeParameter(link, 'time');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: TIMER_REPEAT
                ? `
k_timer_start(&${TIMER_NAME}, K_MSEC(${(Number(time) * 1000).toString()}), K_MSEC(${(Number(time) * 1000).toString()}));
${doneBlock}`

                : `
k_timer_start(&${TIMER_NAME}, K_MSEC(${(Number(time) * 1000).toString()}), K_FOREVER);
${doneBlock}
`,
        });
    }

    return blocks;
};
